import logger from '@salesforce/retail-react-app/app/utils/logger-instance'

/**
 * @async
 * @returns {{success: boolean, publishablekey: string|null, secretkey: string|null, error: any}}
 * @throws {Error} If there's an error during the API call or processing.
 */
const getStripeApiKeys = async (getcustomPreferencevalue) => {
    try {
        let stripeAPIKeysResult = ''
        const publishableKey = getcustomPreferencevalue('pwaStripePublishableKey')
        if (publishableKey) {
            stripeAPIKeysResult = {
                publishableKey,
                secretKey: null
            }
        }

        return stripeAPIKeysResult
    } catch (error) {
        logger.error('stripe Payment', {
            namespace: 'get-stripe-apikeys',
            additionalProperties: {error: error.message}
        })
        return null
    }
}

export default getStripeApiKeys
